import store from "../../../store";
import {
  CABINET_FILTER_NAMES,
  END_CAP_AREA_PART_IDS,
  END_CAP_CABINETS_PART_IDS,
  END_CAP_PART_IDS, SHAPE_PART_ID, SIDEBAR_NAVIGATION_BUTTONS, SQFT_APPLIANCES_WITH_SUBMENU,
  SQFT_AREA_TYPE_PART_IDS, SQFT_FEATURES,
  SQFT_GROUP,
} from "../constants";
import sqftConfig from "../components/canvas/store/sqftConfig";
import { SIDEBAR_NAVIGATION_CABINET_BUTTONS, SQFT_APPLIANCES } from "../constants";
import endCapCanvas from "../components/canvas/core/controls/endCapCanvas";
import {setSelectedFeature, setSelectedHandle, setSelectedHinge} from "../../../actions/sqftResourceFunctions";
import {
  setSelectedCountertop,
  setSelectedWall,
  setSQFTPopup
} from "../../../actions/sqftMenuFunctions";
import SqftOptionsHandlesContent
  from "../components/navigation/menu/cabinet/toolMenu/toolHandles/SqftOptionsHandlesContent";
import workspace from "../components/canvas/core/workspace";
import {closeSQFTPopup} from "../components/canvas/core/controls/resourseCanas";
import React from "react";
import crownMoldingCanvas from "../components/canvas/core/controls/crownmoldingCanvas";
import sqftShapeManager from "../components/canvas/store/sqftShapeManager";
import {is3DMode} from "../components/navigation/NavigationHelper";
import {reloadCountertopsTexturesIn3DMode, reloadShapesIn3DMode} from "./3dHelper/modelsHelper";
import {createApplianceFromFeature} from "./featureHelper";

/**
 * Is SQFT in Area Group TYPE
 */
export const getIsSFTAreaGroup = () => {
  const isSFTAreaGroupInUrl = sqftConfig.isAreaGroupInURL();
  const {sqftState} = store.getState();
  const {sqftFromFeature} = sqftState;

  return isSFTAreaGroupInUrl || sqftFromFeature && (Object.keys(SQFT_AREA_TYPE_PART_IDS).includes(sqftFromFeature.cartFeature.partId));
}

/**
 * Is SQFT in Cabinets Group TYPE
 */
export const isSFTCabinetsGroup = () => {
  const isCabinetGroupInURL = sqftConfig.isCabinetGroupInURL();
  const {sqftState} = store.getState();
  const {SQFTGroup} = sqftState;

  return isCabinetGroupInURL || SQFTGroup === SQFT_GROUP.cabinets;
}

export const getPartIdsFromMenuOpened = (menuOpened) => {
  let partIds = menuOpened ? [menuOpened] : [];
  if (menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland) {
    partIds = ['countertop'];
  } else if (menuOpened === SQFT_APPLIANCES.refrigerator) {
    partIds = ['fridge'];
  } else if (menuOpened === SQFT_APPLIANCES.stovetop) {
    partIds = ['stove'];
  } else if (menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel) {
    partIds = END_CAP_CABINETS_PART_IDS;
  } else if (menuOpened === SIDEBAR_NAVIGATION_BUTTONS.end_cap) {
    partIds = END_CAP_AREA_PART_IDS;
  } else if (menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall) {
    partIds = [SQFT_FEATURES.front_wall];
  } else if (menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles) {
    partIds = [SQFT_FEATURES.top_handle];
  }

  return partIds;
};

export const getSearchTextFromMenuOpened = (menuOpened) => {
  let searchText = "";
  if (menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel) {
    searchText = "";//'End Panel';
  }
  return searchText;
};

export const getItemClickCallbackForPartId = (partId) => {
  let itemClickCallback = new Function();
  if (END_CAP_PART_IDS.includes(partId)) {
    itemClickCallback = (e, feature) => {
      endCapCanvas.setHighlighting(false);
      endCapCanvas.setCursorImage();
      store.dispatch(setSelectedFeature(feature));
    };
  } else if ([
    SQFT_FEATURES.countertop,
    SQFT_FEATURES.vanity_countertop,
    SQFT_FEATURES.center_island_countertop].includes(partId)
  ) {
    itemClickCallback = (e, feature) => {
      store.dispatch(setSelectedCountertop(feature.dbFeature.id));
      // reload 3d models with new parentFeatureId
      (async () => {
        if (is3DMode()) {
          let shapes = workspace.getShapes();
          await reloadCountertopsTexturesIn3DMode(shapes);
        }
      })();
    }
  } else if (partId === SHAPE_PART_ID.front_wall) {
    itemClickCallback = (e, feature) => {
      store.dispatch(setSelectedWall(feature.dbFeature.id));
    }
  } else if (partId === SQFT_FEATURES.hinge) {
    itemClickCallback = (e, feature) => {
      store.dispatch(setSelectedHinge(feature.dbFeature.id));

      const shapes = workspace.getShapesWithoutAttachedResources();
      for (const shape of shapes) {
        if (shape.shapeCabinet?.deleteAttachedFeatures) {
          shape.shapeCabinet.deleteAttachedFeatures(CABINET_FILTER_NAMES.hinges);
          shape.shapeCabinet.generateAttachedFeatures(CABINET_FILTER_NAMES.hinges, { hinges: feature });
        }
      }
    }

  } else if (partId === SQFT_FEATURES.crown_molding) {
    itemClickCallback = (e, feature) => {
      store.dispatch(setSelectedFeature(feature));
      crownMoldingCanvas.setHighlighting(false);
      crownMoldingCanvas.setCursorImage();
    };
  } else if ([
    SQFT_FEATURES.top_cabinet,
    SQFT_FEATURES.bottom_cabinet,
    SQFT_FEATURES.tall_cabinet,
    SQFT_FEATURES.vanity_cabinet,
  ].includes(partId)) {
    itemClickCallback = (e, feature) => {
      store.dispatch(setSelectedFeature(feature));

      // update shape parentFeatureId
      const shapes = workspace.getShapes()
        .filter(shape => shape.parentPartId === partId || shape.grandParentPartId === partId);
      for (const shape of shapes) {
        sqftShapeManager.setShapeRelatedParentFeatureId(shape.id, feature.dbFeature.id, feature.partId);
      }

      // reload 3d models with new parentFeatureId
      (async () => {
        if (is3DMode()) {
          await reloadShapesIn3DMode(shapes);
        }
      })();
    };
  } else if (partId === SQFT_FEATURES.top_handle) {
    itemClickCallback = (e, feature) => {
      store.dispatch(setSelectedHandle(feature));
      store.dispatch(setSQFTPopup(
        {
          title: workspace.intl.formatMessage({id: "sqft.popup.title.applyHandlesTo"}),
          content: <SqftOptionsHandlesContent handlePartId={feature.partId}/>,
          isOpened: true,
          confirmCallback: () => {
            const reduxState = store.getState();
            const selectedPartIds = reduxState.sqftResourceState.selectedPartIds
            const shapes = workspace.getShapesWithoutAttachedResources();
            const selectedShapes = shapes.filter(shape => selectedPartIds.includes(shape.partId));
            for (const selectedShape of selectedShapes) {
              selectedShape.shapeCabinet.deleteAttachedFeatures();
              selectedShape.shapeCabinet.generateAttachedFeatures();
            }

            (async () => {
              if (is3DMode()) {
                await reloadShapesIn3DMode(selectedShapes);
              }
            })();

            closeSQFTPopup();
          },
          confirmText: workspace.intl.formatMessage({id: "sqft.popup.button.generate"}),
          cancelCallback: closeSQFTPopup,////closePopup,
          cancelText: workspace.intl.formatMessage({id: "sqft.popup.button.cancel"}),
        }
      ));
    }
  } else if (SQFT_APPLIANCES_WITH_SUBMENU.includes(partId)) {
    itemClickCallback = (e, feature) => {
      createApplianceFromFeature(feature);
    };
  } else if (partId === SQFT_FEATURES.countertop) {
    itemClickCallback = (e, feature) => {
      setSelectedCountertop(feature.dbFeature.id);
    };
  }

  return itemClickCallback;
};
